import * as React from 'react'

import { IconProps } from '@zet/design-system/icons'
import Svg, { Path } from 'react-native-svg'

const Salaried = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg width={`${size}px`} height={`${size}px`} viewBox="0 0 20 20" {...props}>
    <Path
      d="M23.5 20a4 4 0 0 1-4 4h-15a4 4 0 0 1-4-4v-7.646a4 4 0 0 1 1.289-2.941l7.5-6.914a4 4 0 0 1 5.422 0l7.5 6.914a4 4 0 0 1 1.289 2.941V20Z"
      fill="#AAD5FF"
    />
    <Path
      d="M23.5 11.127a1.2 1.2 0 0 0-.387-.882l-9.1-8.389C13.245 1.147 12 1.693 12 2.738V22.8a1.2 1.2 0 0 0 1.2 1.2h9.1a1.2 1.2 0 0 0 1.2-1.2V11.127Z"
      fill="#6DB6FF"
    />
    <Path d="M1.73 5.271h20.543v12.212H1.729V5.27Z" fill="#389CFF" />
    <Path d="M12 5.271h10.272v12.212H12V5.27Z" fill="#2E86DD" />
    <Path d="M3.354 6.87H20.65v9.015H3.354V6.87Z" fill="#D5EAFF" />
    <Path d="M12 6.87h8.648v9.015H12V6.87Z" fill="#AFD7FF" />
    <Path
      d="M12 14.578c1.242 0 2.248-1.433 2.248-3.2 0-1.768-1.006-3.2-2.248-3.2-1.242 0-2.249 1.432-2.249 3.2 0 1.767 1.007 3.2 2.249 3.2Z"
      fill="#fff"
    />
    <Path
      d="M14.249 11.378c0-1.767-1.008-3.2-2.249-3.2v6.4c1.242 0 2.249-1.433 2.249-3.2Z"
      fill="#F5F7FB"
    />
    <Path
      d="M6.218 12.906c.838 0 1.517-.684 1.517-1.528S7.056 9.85 6.218 9.85c-.838 0-1.517.684-1.517 1.528s.68 1.528 1.517 1.528ZM17.783 12.906c.838 0 1.517-.684 1.517-1.528s-.68-1.528-1.517-1.528c-.838 0-1.517.684-1.517 1.528s.68 1.528 1.517 1.528Z"
      fill="#fff"
    />
    <Path d="M.5 10.602V24h23L.5 10.602Z" fill="#CEE7FF" />
    <Path d="M23.5 10.602.5 24h23V10.602Z" fill="#AAD5FF" />
    <Path d="M12 17.3V24h11.5L12 17.3Z" fill="#6DB6FF" />
  </Svg>
)

export default Salaried
